import React from 'react';
import Typography from 'new/elements/Typography';
import { FormConfigurationStep } from 'new/components/FormConfigurationStep/FormConfigurationStep';
import DataSourceDetails from '../DataSourceDetails/DataSourceDetails';
import styles from './SyslogConfiguration.module.scss';
import { Divider } from '@mui/material';
import CodeContainer from 'js/components/data_sources/add_ds_form/SyslogConfiguration/SyslogCodeContainer';
import { API_SYSLOG_SERVER_URL } from 'js/constants/api';

type SyslogConfigurationProps = {
  name: string;
  enableCategoryHeader?: boolean;
  description?: string;
  selectedConnection: string;
  sourceBeingEdited?: any;
  sourceConfig?: Record<string, any>;
  onSourceConfigChanged(a: Record<string, any>): void;
  onInputChange(a: Record<string, any>): void;
  selectedConnectionDetails: any;
};

const payloadSchema = (sourceId = '', datasetId = '') => `{
  //..all syslog data
}`;

export function SyslogConfiguration(props: SyslogConfigurationProps) {
  const {
    name,
    description,
    onInputChange,
    selectedConnectionDetails,
    sourceBeingEdited,
    enableCategoryHeader = false,
  } = props;

  const syslogServerUrl = API_SYSLOG_SERVER_URL || '';
  const payload = payloadSchema('', '');

  return (
    <div className={styles.container}>
      <DataSourceDetails
        name={name}
        description={description}
        onInputChange={onInputChange}
        selectedConnectionDetails={selectedConnectionDetails}
      />
      <FormConfigurationStep enableCategoryHeader={false} connectionName="Syslog">
        <section className={styles.content}>
          <div className={styles.description}>
            <Typography variant="bodyDefault">
              This configuration page provides everything you need to stream syslog data from your
              server to Nexla's data integration platform.
              <br />
              <br />
              Click the <b>Create</b> button above to create a new source and an associated Nexset.
              Once the source and nexset are created, you can configure your Syslog server to send
              data to Nexla by following the instructions below.
              <br />
              <br />
              <em>
                <b>Note:</b>You will also find these instructions in the source's detail panel page
                with the relevant configuration details.
              </em>
            </Typography>
            <Divider />
            <CodeContainer
              toCopy={`${syslogServerUrl}`}
              value={`${syslogServerUrl}`}
              label="Endpoint URL"
            />
            <br />
            <Typography variant="subtitle2">Authentication</Typography>
            <Typography variant="bodyDefault">
              All requests to this endpoint must be authenticated using Bearer Token authorization.
              The Token is generated by Nexla after the source is created and is available in the
              source's detail panel tab.
            </Typography>
            <br />
            <Typography variant="subtitle2">Payload</Typography>
            <Typography variant="bodyDefault">
              Send your syslog data as JSON payloads to this endpoint. The JSON should contain all
              the log data fields you want to ingest into Nexla.
              <br />
              <CodeContainer toCopy={payload} value={payload} label="" />
            </Typography>
          </div>
        </section>
      </FormConfigurationStep>
    </div>
  );
}
